(function(){
  function moneyFormat(cents, format){
    format = format || '${{amount}}';
    var numeric = Number(cents || 0);
    var value = (numeric / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(numeric / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  }

  function normalizeCode(value){
    return String(value || '').trim().toUpperCase();
  }

  function updateHeaderCartCount(count){
    document.querySelectorAll('.valse-cart b').forEach(function(el){ el.textContent = count; });
  }

  function showMaxQtyMessage(input){
    var wrap = input && input.closest('.valse-form-row');
    var msg = wrap && wrap.querySelector('[data-qty-limit-message]');
    if(msg){ msg.hidden = false; clearTimeout(msg._timer); msg._timer = setTimeout(function(){ msg.hidden = true; }, 2200); }
  }
  function clampProductQuantity(input){
    if(!input || !input.matches('[data-product-quantity]')) return;
    var max = parseInt(input.max || '5', 10) || 5;
    var min = parseInt(input.min || '1', 10) || 1;
    var val = parseInt(input.value || String(min), 10) || min;
    if(val > max){ input.value = max; showMaxQtyMessage(input); }
    else if(val < min){ input.value = min; }
    var plus = input.closest('[data-qty-wrap]') && input.closest('[data-qty-wrap]').querySelector('[data-qty-plus]');
    if(plus){ plus.classList.toggle('is-max', parseInt(input.value || '1', 10) >= max); }
  }
  function isBundleActive(form){
    return form && String(form.dataset.bundleActive || '').toLowerCase() === 'true';
  }

  function updateDiscountPreview(form){
    if(!form) return;
    var format = form.dataset.moneyFormat || '${{amount}}';
    var baseTotal = Number(form.dataset.cartSubtotalCents || form.dataset.cartTotal || 0);
    var row = form.querySelector('[data-discount-row]');
    var totalEl = form.querySelector('[data-cart-estimated-total]');
    if(row) row.style.display = 'none';
    if(totalEl) totalEl.textContent = moneyFormat(baseTotal, format);
  }

  function checkoutFromCart(form){
    window.location.href = '/checkout';
  }

  function setCartError(form, message){
    if(!form) return;
    var el = form.querySelector('[data-cart-error]');
    if(!el){
      el = document.createElement('p');
      el.setAttribute('data-cart-error', '');
      el.className = 'valse-muted';
      el.style.cssText = 'margin:10px 0 0;color:#D8C3A5;font-weight:800';
      var summary = form.querySelector('[data-cart-summary]');
      (summary || form).appendChild(el);
    }
    el.textContent = message || '';
  }

  function updateCartQuantity(input){
    if(!input) return;
    var form = input.closest('[data-cart-form]');
    var quantity = Math.max(0, parseInt(input.value || '0', 10));
    var line = parseInt(input.dataset.cartLine || '0', 10);
    var key = input.dataset.cartKey;
    input.value = quantity;
    setCartError(form, '');

    var payload = {id: key, quantity: quantity};
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(payload)
    }).then(function(response){
      if(!response.ok){
        return response.json().catch(function(){ return {}; }).then(function(data){ throw new Error(data.description || data.message || 'Cart quantity could not be updated.'); });
      }
      return response.json();
    }).then(function(cart){
      if(!form) return;
      var safeSubtotal = cart.items_subtotal_price || cart.original_total_price || cart.total_price || 0;
      form.dataset.cartTotal = safeSubtotal;
      form.dataset.cartSubtotalCents = safeSubtotal;
      var format = form.dataset.moneyFormat || '${{amount}}';
      var subtotal = form.querySelector('[data-cart-subtotal]');
      if(subtotal) subtotal.textContent = moneyFormat(safeSubtotal, format);
      var total = form.querySelector('[data-cart-estimated-total]');
      if(total) total.textContent = moneyFormat(safeSubtotal, format);
      updateHeaderCartCount(cart.item_count || 0);

      if(quantity === 0 || cart.item_count === 0){
        window.location.reload();
        return;
      }

      var rows = Array.prototype.slice.call(form.querySelectorAll('[data-cart-item]'));
      rows.forEach(function(row){ row.setAttribute('data-still-present', 'false'); });

      (cart.items || []).forEach(function(item, index){
        var row = rows.find(function(candidate){ return candidate.getAttribute('data-cart-item') === item.key; }) || rows[index];
        if(row){
          row.setAttribute('data-still-present', 'true');
          row.setAttribute('data-cart-item', item.key);
          var price = row.querySelector('[data-line-price]');
          if(price) price.textContent = moneyFormat(item.final_line_price, format);
          var qty = row.querySelector('[data-cart-qty]');
          if(qty){
            qty.value = item.quantity;
            qty.dataset.cartKey = item.key;
            qty.dataset.cartLine = index + 1;
          }
        }
      });

      document.dispatchEvent(new CustomEvent('valse:cart-updated', { detail: { cart: cart } }));
      updateDiscountPreview(form);
    }).catch(function(error){
      setCartError(form, error.message || 'Cart quantity could not be updated. Please refresh and try again.');
    });
  }

  function currentProductUnitPrice(productRoot){
    var priceWrap = productRoot && productRoot.querySelector('[data-product-price-wrap]');
    if(!priceWrap) return {price:0, compare:0, format:'${{amount}}'};
    var select = productRoot.querySelector('[data-variant-select]');
    if(select && select.selectedOptions && select.selectedOptions.length){
      var opt = select.selectedOptions[0];
      priceWrap.dataset.unitPrice = opt.dataset.price || priceWrap.dataset.unitPrice || 0;
      priceWrap.dataset.comparePrice = opt.dataset.comparePrice || 0;
    }
    return {
      price: Number(priceWrap.dataset.unitPrice || 0),
      compare: Number(priceWrap.dataset.comparePrice || 0),
      format: priceWrap.dataset.moneyFormat || '${{amount}}'
    };
  }

  function updateProductPrice(form){
    if(!form) return;
    var productRoot = form.closest('.valse-product') || document;
    var priceWrap = productRoot.querySelector('[data-product-price-wrap]');
    if(!priceWrap) return;
    var priceEl = priceWrap.querySelector('[data-product-price]');
    var compareEl = priceWrap.querySelector('[data-product-compare]');
    var noteEl = priceWrap.querySelector('[data-product-price-note]');
    var qtyInput = form.querySelector('[data-product-quantity]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10));
    var discount = 0;
    var selectedBundle = null;
    var options = Array.prototype.slice.call(form.querySelectorAll('[data-bundle-qty]'));

    options.forEach(function(btn){
      var optionQty = Math.max(1, parseInt(btn.dataset.bundleQty || '1', 10));
      if(qty === optionQty || (qty >= 3 && optionQty >= 3 && (!selectedBundle || optionQty > parseInt(selectedBundle.dataset.bundleQty || '0', 10)))){
        selectedBundle = btn;
      }
    });
    if(!selectedBundle && qty === 1) selectedBundle = form.querySelector('[data-bundle-qty="1"]') || options[0];
    if(selectedBundle) discount = Math.max(0, Number(selectedBundle.dataset.bundleDiscount || 0));

    if(options.length){
      options.forEach(function(btn){ btn.classList.toggle('is-active', btn === selectedBundle); });
    }
    var bundleFlag = form.querySelector('[data-bundle-flag]');
    var bundleLabel = form.querySelector('[data-bundle-label]');
    if(bundleFlag) bundleFlag.value = (qty >= 2 && discount > 0) ? 'true' : 'false';
    if(bundleLabel){
      var labelText = selectedBundle && selectedBundle.querySelector('strong') ? selectedBundle.querySelector('strong').textContent.trim() : '';
      bundleLabel.value = (qty >= 2 && discount > 0) ? labelText : '';
    }

    var pricing = currentProductUnitPrice(productRoot);
    var regularTotal = pricing.price * qty;
    var displayTotal = Math.round(regularTotal * (100 - discount) / 100);

    if(priceEl) priceEl.textContent = moneyFormat(displayTotal, pricing.format);
    if(compareEl){
      if(discount > 0 && regularTotal > displayTotal){
        compareEl.hidden = false;
        compareEl.textContent = moneyFormat(regularTotal, pricing.format);
      } else if(pricing.compare > pricing.price && qty === 1){
        compareEl.hidden = false;
        compareEl.textContent = moneyFormat(pricing.compare, pricing.format);
      } else {
        compareEl.hidden = true;
      }
    }
    if(noteEl){
      if(qty > 1 && discount > 0) noteEl.textContent = 'Quantity savings preview: ' + discount + '% off';
      else if(qty > 1) noteEl.textContent = qty + ' items selected';
      else noteEl.textContent = '';
    }
  }

  function updateVariantAvailability(select){
    var form = select && select.closest('form');
    if(!form || !select.selectedOptions || !select.selectedOptions.length) return;
    var available = String(select.selectedOptions[0].dataset.available) === 'true';
    var add = form.querySelector('.valse-product-form__add');
    var stock = form.querySelector('[data-stock-status]');
    var restock = form.querySelector('.restock-note');
    var dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    if(add){ add.disabled = !available; add.textContent = available ? (add.getAttribute('data-add-label') || 'Add to Cart') : (add.getAttribute('data-sold-label') || 'Sold Out'); }
    if(dynamicCheckout){ dynamicCheckout.hidden = !available; }
    if(stock){ stock.className = available ? 'stock-status in-stock' : 'stock-status out-of-stock'; stock.innerHTML = available ? '<span>✓</span> In Stock — Ready to Ship' : '<span>✕</span> Currently Unavailable'; }
    if(restock) restock.hidden = available;
    updateProductPrice(form);
  }

  function handleProductCardSubmit(form){
    if(!form) return;
    var button = form.querySelector('button[type="submit"]');
    var original = button ? button.textContent : '';
    var id = form.querySelector('input[name="id"]');
    if(!id || !id.value){
      window.location.href = form.getAttribute('data-product-url') || '/collections/all';
      return;
    }
    if(button){ button.disabled = true; button.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept':'application/json'},
      body: new FormData(form)
    }).then(function(response){
      if(!response.ok){
        return response.json().catch(function(){ return {}; }).then(function(data){ throw new Error(data.description || data.message || 'Could not add this item.'); });
      }
      return fetch('/cart.js', {headers:{'Accept':'application/json'}});
    }).then(function(response){ return response.json(); })
    .then(function(cart){
      updateHeaderCartCount(cart.item_count || 0);
      if(button){ button.textContent = 'Added'; setTimeout(function(){ button.textContent = original; button.disabled = false; }, 1200); }
    }).catch(function(){
      if(button){ button.textContent = 'Choose options'; button.disabled = false; }
      var url = form.getAttribute('data-product-url');
      if(url) window.location.href = url;
    });
  }


  function switchProductGalleryImage(gallery, direction){
    if(!gallery) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumb]'));
    if(!thumbs.length) return;
    var activeIndex = thumbs.findIndex(function(btn){ return btn.classList.contains('is-active'); });
    if(activeIndex < 0) activeIndex = 0;
    var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
    thumbs[nextIndex].click();
  }

  document.addEventListener('click', function(event){
    var prevArrow = event.target.closest('[data-product-gallery-prev]');
    var nextArrow = event.target.closest('[data-product-gallery-next]');
    if(prevArrow || nextArrow){
      var arrowGallery = event.target.closest('[data-product-gallery]');
      switchProductGalleryImage(arrowGallery, prevArrow ? -1 : 1);
      return;
    }

    var thumb = event.target.closest('[data-product-thumb]');
    if(thumb){
      var gallery = thumb.closest('[data-product-gallery]');
      var main = gallery && gallery.querySelector('[data-product-main-image]');
      if(main && thumb.dataset.full){
        main.removeAttribute('srcset');
        main.src = thumb.dataset.full;
        main.alt = thumb.dataset.alt || main.alt;
        gallery.querySelectorAll('[data-product-thumb]').forEach(function(btn){ btn.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
      return;
    }

    var bundle = event.target.closest('[data-bundle-qty]');
    if(bundle){
      var form = bundle.closest('form');
      var qty = form && form.querySelector('input[name="quantity"]');
      var bundleFlag = form && form.querySelector('[data-bundle-flag]');
      var bundleLabel = form && form.querySelector('[data-bundle-label]');
      var selectedQty = Math.max(1, parseInt(bundle.dataset.bundleQty || '1', 10));
      var discount = Math.max(0, Number(bundle.dataset.bundleDiscount || 0));
      if(qty){
        qty.value = selectedQty;
        qty.dispatchEvent(new Event('change', {bubbles:true}));
      }
      if(bundleFlag) bundleFlag.value = (selectedQty >= 2 || discount > 0) ? 'true' : 'false';
      if(bundleLabel) bundleLabel.value = (selectedQty >= 2 || discount > 0) ? (bundle.querySelector('strong') ? bundle.querySelector('strong').textContent.trim() : 'Quantity savings') : '';
      if(form){
        form.querySelectorAll('[data-bundle-qty]').forEach(function(btn){ btn.classList.remove('is-active'); });
      }
      bundle.classList.add('is-active');
      updateProductPrice(form);
      return;
    }

    var apply = event.target.closest('[data-discount-apply]');
    if(apply){
      updateDiscountPreview(apply.closest('[data-cart-form]'));
      return;
    }

    var checkout = event.target.closest('[data-cart-checkout]');
    if(checkout){
      event.preventDefault();
      checkoutFromCart(checkout.closest('[data-cart-form]'));
      return;
    }

    var dec = event.target.closest('[data-qty-minus]');
    var inc = event.target.closest('[data-qty-plus]');
    if(!dec && !inc) return;
    var wrap = event.target.closest('[data-qty-wrap]');
    if(!wrap) return;
    var input = wrap.querySelector('input[type="number"]');
    if(!input) return;
    var min = parseInt(input.min || '1', 10);
    var val = parseInt(input.value || min, 10);
    var max = parseInt(input.max || '9999', 10);
    var next = Math.max(min, val + (inc ? 1 : -1));
    if(inc && input.matches('[data-product-quantity]') && next > max){ next = max; showMaxQtyMessage(input); }
    input.value = next;
    clampProductQuantity(input);
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  document.addEventListener('submit', function(event){
    var cardForm = event.target.closest('[data-product-card-form]');
    if(cardForm){
      event.preventDefault();
      handleProductCardSubmit(cardForm);
    }
  });

  document.addEventListener('change', function(event){
    if(event.target.matches('[data-cart-qty]')) updateCartQuantity(event.target);
    if(event.target.matches('[data-variant-select]')) updateVariantAvailability(event.target);
    if(event.target.matches('[data-product-quantity]')){ clampProductQuantity(event.target); updateProductPrice(event.target.closest('form')); }
  });

  document.addEventListener('input', function(event){
    if(event.target.matches('[data-discount-input]')) updateDiscountPreview(event.target.closest('[data-cart-form]'));
    if(event.target.matches('[data-product-quantity]')){ clampProductQuantity(event.target); updateProductPrice(event.target.closest('form')); }
  });

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-discount-message]').forEach(function(el){
      el.setAttribute('data-default', el.textContent);
      if(!el.getAttribute('data-bundle-text')) el.setAttribute('data-bundle-text', el.textContent);
    });
    document.querySelectorAll('[data-cart-form]').forEach(updateDiscountPreview);
    document.querySelectorAll('.valse-product-form').forEach(updateProductPrice);


    window.addEventListener('load', function(){
      document.querySelectorAll('.product-card__image img, .card__image, .product__media img, .product-thumbnail img, .collection-card img, .valse-product__main-image img, .valse-product__thumb img, .cart-item__image img').forEach(function(img){
        var inProductCard = img.closest('.product-card__image') || img.closest('.collection-card');
        img.style.objectFit = inProductCard ? 'cover' : 'contain';
        img.style.objectPosition = 'center center';
      });
    });

    var params = new URLSearchParams(window.location.search);
    if(params.size){
      var map = {order: ['order','order_number'], email: ['email'], topic: ['topic'], message: ['message','body']};
      Object.keys(map).forEach(function(key){
        var el = document.querySelector('[data-prefill="' + key + '"]');
        if(!el) return;
        var value = '';
        map[key].some(function(name){ value = params.get(name) || ''; return !!value; });
        if(value) el.value = value;
      });
    }
  });
})();

/* Valse product page smart add: prevents split lines like 2 + 1 for the same variant */
(function(){
  async function smartAddToCart(variantId, qty, form){
    var cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json()});
    var existing = (cart.items || []).find(function(item){ return String(item.variant_id) === String(variantId); });
    if(existing){
      return fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:existing.key,quantity:existing.quantity+qty})}).then(function(r){if(!r.ok){return r.json().catch(function(){return{}}).then(function(data){throw new Error(data.description||data.message||'Could not update this item.')});}return r.json()});
    }
    var fd = new FormData(form);fd.set('quantity', String(qty));
    return fetch('/cart/add.js', {method:'POST',headers:{'Accept':'application/json'},body:fd}).then(function(r){if(!r.ok){return r.json().catch(function(){return{}}).then(function(data){throw new Error(data.description||data.message||'Could not add this item.')});}return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(x){return x.json()});});
  }
  function toast(text){var el=document.querySelector('[data-valse-cart-toast]');if(!el){el=document.createElement('div');el.className='valse-cart-toast';el.setAttribute('data-valse-cart-toast','');document.body.appendChild(el);}el.innerHTML='<span>'+(text||'✓ Added to cart')+'</span><a class="valse-cart-toast__link" href="/cart" aria-label="View cart">View cart</a>';el.classList.add('is-visible');document.documentElement.classList.add('valse-cart-just-added');clearTimeout(toast.t);toast.t=setTimeout(function(){document.documentElement.classList.remove('valse-cart-just-added')},6500)}
  document.addEventListener('submit',function(e){var form=e.target&&e.target.closest&&e.target.closest('.valse-product-form');if(!form||e.target.closest('[data-product-card-form]'))return;var submitter=e.submitter||document.activeElement;if(submitter&&submitter.name&&submitter.name!=='add')return;e.preventDefault();e.stopImmediatePropagation();var isBuyNow=!!(submitter&&submitter.closest&&submitter.closest('[data-product-buy-now-to-cart]'));var idEl=form.querySelector('[name="id"]');var qtyEl=form.querySelector('[name="quantity"]');var btn=isBuyNow?submitter:form.querySelector('.valse-product-form__add');if(!idEl||!idEl.value)return;var qty=Math.max(1,parseInt((qtyEl&&qtyEl.value)||'1',10)||1);if(qty>5){qty=5;if(qtyEl)qtyEl.value='5';}var original=btn?btn.textContent:'';if(btn){btn.disabled=true;btn.textContent=isBuyNow?'Opening cart...':'Adding...';}smartAddToCart(idEl.value,qty,form).then(function(cart){document.querySelectorAll('.valse-cart b').forEach(function(el){el.textContent=cart.item_count||0;el.classList.add('valse-cart-count-bounce');setTimeout(function(){el.classList.remove('valse-cart-count-bounce')},350)});if(isBuyNow){window.location.href='/cart';return;}toast('✓ Product added to your cart');if(btn){btn.textContent='✓ Added';setTimeout(function(){btn.textContent=original;btn.disabled=false},1400);}}).catch(function(err){toast(err.message||'This item could not be added.');if(btn){btn.textContent=original;btn.disabled=false;}});},true);
})();

(function valseFooterScrollToTop(){
  document.addEventListener('click', function(event){
    var link = event.target && event.target.closest && event.target.closest('[data-scroll-to-top]');
    if(!link) return;
    event.preventDefault();
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if (history && history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    } catch (e) {
      window.location.hash = 'top';
    }
  });
})();

